import _Map from "@babel/runtime-corejs3/core-js/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { useInstance } from 'intact-vue';
import { isNullOrUndefined, isStringOrNumber } from 'intact-shared';
import { isEmptyString, getTextByChildren } from '../utils';
export function useBaseLabel(getChildren, findLabelFromChildren) {
  var instance = useInstance();
  var labelMap = new _Map();
  function getLabel() {
    var _instance$get = instance.get(),
      value = _instance$get.value,
      multiple = _instance$get.multiple;
    var children = getChildren();
    if (isNullOrUndefined(value)) return;
    if (!multiple) {
      return findLabel(children, value);
    } else {
      var labels = [];
      value.forEach(function (value) {
        var label = findLabel(children, value);
        if (!isNullOrUndefined(label)) {
          labels.push(label);
        }
      });
      return labels;
    }
  }
  function findLabel(children, value) {
    var label = findLabelFromChildren(children, value);
    if (isNullOrUndefined(label)) {
      label = labelMap.get(value);
    } else {
      if (instance.get('filterable')) {
        label = getTextByChildren(label);
      }
      labelMap.set(value, label);
    }
    label = isEmptyString(label) ? isStringOrNumber(value) ? value : null : label;
    return label;
  }
  function cleanMap() {
    var _instance$get2 = instance.get(),
      value = _instance$get2.value,
      multiple = _instance$get2.multiple;
    if (isNullOrUndefined(value)) {
      labelMap.clear();
      return;
    }
    if (multiple) {
      labelMap.forEach(function (item, key) {
        if (!_includesInstanceProperty(value).call(value, key)) {
          labelMap.delete(key);
        }
      });
      return;
    }
    labelMap.forEach(function (item, key) {
      if (key !== value) {
        labelMap.delete(key);
      }
    });
  }
  instance.watch('value', cleanMap, {
    inited: true
  });
  return {
    getLabel: getLabel
  };
}